module.exports = __webpack_public_path__ + "img/segitiga-putih-chat.1ccdbcb2.svg";